"use strict";

module.exports = function () {
    return {
        restrict: "E",
        replace: false,
        scope: {
            enquiryId: "="
        },
        controller: "enquiryFinanceEditor.controller",
        controllerAs: "vm",
        templateUrl: "app/independentLiving/directives/partials/enquiryFinanceEditor.html"
    };
}
